/**
 * Integración Davinci -> Printer API para el área SIP&FLY.
 *
 * IMPORTANTE:
 * Este servicio es EXCLUSIVO para SIP&FLY.
 *
 * Cocina, Bar, Dotcom, Servicios y Recepción conservan
 * el flujo tradicional de impresión de Davinci mediante
 * ticketPrinter / orozcoPrints.
 */

const SIP_AND_FLY_PRINTER_API_BY_LOUNGE = {
    TGLE: 'https://printer-tgle.sipandfly.com.mx',
    L19: 'https://printer-tgle.sipandfly.com.mx',
    CELESTE: 'https://printer-tgle.sipandfly.com.mx',
    HAVEN: 'https://printer-tgle.sipandfly.com.mx',
};

export const getSipAndFlyPrinterApiUrl = (lounge) => {
    if (!lounge || !lounge.name)
        return null;

    return SIP_AND_FLY_PRINTER_API_BY_LOUNGE[
        String(lounge.name).trim().toUpperCase()
    ] || null;
};

export const isSipAndFlyPrinterConfigured = (lounge) =>
    !!getSipAndFlyPrinterApiUrl(lounge);

/**
 * Envía una comanda SIP&FLY a la Printer API centralizada en TGLE.
 *
 * @param {Object} lounge Sala actual de Davinci.
 * @param {Object} payload Contrato Printer API.
 * @returns {Promise<Object>}
 */
export const printSipAndFly = async (lounge, payload) => {
    const baseUrl = getSipAndFlyPrinterApiUrl(lounge);

    if (!baseUrl) {
        throw new Error(
            'La impresión SIP&FLY no está configurada para esta sala'
        );
    }

    const response = await fetch(
        `${baseUrl}/print-sipandfly`,
        {
            method: 'POST',
            mode: 'cors',
            credentials: 'omit',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        }
    );

    let responseData = null;

    try {
        responseData = await response.json();
    }
    catch (e) {
        // La validación HTTP se realiza abajo.
    }

    if (!response.ok) {
        const message =
            responseData && responseData.error
                ? responseData.error
                : `Error HTTP ${response.status} al imprimir en SIP&FLY`;

        throw new Error(message);
    }

    if (responseData && responseData.ok === false) {
        throw new Error(
            responseData.error || 'La Printer API rechazó la impresión SIP&FLY'
        );
    }

    return responseData || {ok: true};
};
